import React, { memo } from 'react';
import { createUseStyle } from '@redlink/assets/styles';
import { Text } from '@redlink/components/atoms';
import { DataGridColumn } from './dataGridColumn';

export const DataGridSimpleTextColumn = memo(
  ({ renderColumn, style, hovered, ...rest }) => {
    const { styles } = useStyle();
    return (
      <DataGridColumn
        {...rest}
        renderColumn={(item, value) => (
          <Text
            style={[
              styles.simpleText,
              style,
              // hovered && styles.simpleTextHover,
            ]}
          >
            {value}
          </Text>
        )}
      />
    );
  }
);

const useStyle = createUseStyle(({ colors, size }) => ({
  simpleText: {
    color: colors.gray23,
    fontSize: 14,
  },
  simpleTextHover: {
    color: colors.blue1,
  },
}));
